import { gql } from '@apollo/client'
import { truckRatingsFragment } from 'components/pages/TruckPage/TruckRatings'
import { truckInformationFragment } from 'components/HeroSection/TruckInformationSectionContent'

export default gql`
  ${truckRatingsFragment}
  ${truckInformationFragment}
  query truckMenuQuery($seoName: String!) {
    truck(seoName: $seoName) {
      id
      slug
      redirectToTruck {
        id
        menuPath
      }
      ...truckInformationFragment
      menus {
        id
        name
        active
        public
        name
        hasPrices
        taxIncluded
        items(sort: [{ field: auto, direction: asc }]) {
          id
          name
          description
          active
          image {
            medium
            present
          }
          upsellType {
            id
            name
            position
          }
          price {
            formatted
          }
          tags {
            id
            highlighted
            imageSvgUrl
            name
          }
          itemQuestions {
            id
            active
            text
            itemAnswers {
              id
              active
              adjustment {
                formatted
              }
              text
            }
          }
        }
        foodTypes {
          id
          name
        }
      }
      image {
        medium
        original
      }
      restaurant {
        id
        active
        logo {
          thumb
          medium
          original
        }
      }
      currentOrNextLocation {
        id
      }
      primaryUpsellTypes {
        id
        name
      }
      ...truckRatingsFragment
    }
    upsellTypes {
      id
      name
    }
    structuredData {
      truckMenuPage(seoName: $seoName)
    }
  }
`
